import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default assets for the Film Trailer component.
 */
export const defaultFilmTrailerAssets = {
    failedToLoadTrailerIconName: 'generic-error-message'
};
export const filmTrailerAssetsValidatorSchema = {
    failedToLoadTrailerIconName: nonEmptyStringValidator
};
export const filmTrailerAssetsValidator = Validator.object(filmTrailerAssetsValidatorSchema);
